export default "../images/stackloans-partners-with-avant.png?1334788e41e2991c030a0c2f17828780";